<template>
    <div :class="[isVerticalAligned?'spinner-background-vertical-aligned':'spinner-background']">
        <div class="spinner" :style="spinnerStyle">
            <div class="outer-ring" :style="outerRingStyles"></div>
            <div class="colored-outer-ring" :style="coloredOuterRingStyles" ></div>
            <div class="colored-outer-ring" :style="secondColoredOuterRingStyles" ></div>
            <div class="inner-ring" :style="innerRingStyles"></div>
            <div class="tracking-dot-wrapper" :style="trackingDotWrapperStyles">
                <div class="tracking-dot" :style="trackingDotStyles"></div>
            </div>
            <div class="spinner-text-wrapper">
                <span class="spinner-text" >{{ text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "SpeenComponent",
    components:{},
    props:{
        isAutomatic: Boolean,
        ringWidth: Number,
        spinnerSize: Number,
        dotColor: String,
        dotPosition: Number,
        isVerticalAligned: Boolean,
        text: String,
        machineId: Number,
        resizeable: {
            type: Boolean,
            default: false
        }

    },
    data(){
        return{
            finalSpinnerRelativeSize:80,
            ringColor:'green',
            finalDotPosition:0,
            finalDotColor:'green',
            barBaseColor: 'white',
            barColor: 'green',
            scale: 1,
            resizeInterval: null
        }
    },
    methods:{

        resize(){
            let self = this;
            //TODO: Por ciertas complicaciones con el CSS, verticalmente se utilizara un modificador. HAY QUE ARREGLAR EL CSS DEL SPINNER
            let vScale = (self.$el && self.$el.clientHeight) && (self.$parent.$el && self.$parent.$el.clientHeight) > 0  ?  Math.round(((self.$parent.$el.clientHeight*0.8) / self.$el.clientHeight)*100 )/100 : 1,
                hScale = (self.$el && self.$el.clientWidth) && (self.$parent.$el && self.$parent.$el.clientWidth) > 0  ?  Math.round(((self.$parent.$el.clientWidth) / self.$el.clientWidth)*100 )/100 : 1
            self.scale = (Math.min(vScale, hScale));
            // self.scale *= 0.95; // Para compensar un margen
        }
    },
    mounted(){
        if (this.resizeable){
            window.addEventListener('resize', this.resize);
            this.resizeInterval = setInterval(()=>{this.resize()}, 2000);
        }

        if(this.dotColor) this.finalDotColor = this.dotColor;
        if(this.dotPosition) this.finalDotPosition = this.dotPosition;
        if(this.spinnerSize) this.finalSpinnerRelativeSize = this.spinnerSize;
    },
    beforeDestroy() {
        clearInterval(this.resizeInterval)
    },
    computed:{
        ...mapGetters('monitorization',['activeMachineById']),
        spinnerStyle(){
            return {
                width: `${this.finalSpinnerRelativeSize}%`,
                transform: `scale(${this.scale})`,
                transformOrigin:'center'

            }
        },
        outerRingStyles(){
            return {
                background: this.ringColor
            }
        },
        coloredOuterRingStyles(){
            let porc = Math.min(100, Math.max(0, (this.actualMachine?this.actualMachine.completed_percentage:0)));
            let degPos = (360/100)* porc;
            return {
                background: `${porc <= 50? `linear-gradient(${ porc <=50? 90 + degPos: 90}deg, transparent 50%, ${porc<=50?this.barBaseColor:this.ringColor} 50%),`: ''  }
                linear-gradient(${porc > 50? 90 + (degPos - 180): 90 }deg, ${this.barBaseColor} 50%, transparent 50%) `
            }
        },
        secondColoredOuterRingStyles(){
            let porc = Math.min(100, Math.max(0, (this.actualMachine?this.actualMachine.completed_percentage:0)));
            let degPos = (360/100)* porc;
            return {
                background: `${porc > 50? `linear-gradient(90deg , transparent 50%, ${this.ringColor} 50%)`: 'transparent'}`
            }

        },
        innerRingStyles(){
            let innerRingWith = 100 - this.ringWidth;
            let margin = Math.round(this.ringWidth/2)
            return {
                width: `${innerRingWith}%`,
                height: `${innerRingWith}%`,
                margin: `${margin}%`
            }
        },
        trackingDotWrapperStyles(){
            let dotPos = (360/100)* (this.actualMachine?this.actualMachine.completed_percentage:0);

            return {
                transform: `rotate(${dotPos}deg) ${this.isAutomatic?'':'!important'}`,
                animationPlayState: `${this.isAutomatic?'running':'paused'}`
            }
        },
        trackingDotStyles(){
            let dotWidth = this.ringWidth;
            return {
                width: `${dotWidth}%`,
                height: `${dotWidth}%`,
                background: this.finalDotColor
            }
        },
        actualMachine(){
            return this.activeMachineById(this.machineId)
        }
    }
}
</script>

<style >

</style>
